import React from "react";

function buildCopy(overLimitReasons, songCount, setlistCount) {
  const hasSongs = overLimitReasons.includes("songs");
  const hasSetlists = overLimitReasons.includes("setlists");

  if (hasSongs && hasSetlists) {
    return (
      `You have ${songCount} songs and ${setlistCount} setlists. ` +
      `The Free plan includes 20 songs and 1 setlist. ` +
      `Your library and setlists are safe — upgrade to add more.`
    );
  }
  if (hasSongs) {
    return (
      `You have ${songCount} songs. The Free plan includes 20. ` +
      `Your library is safe — upgrade to add more.`
    );
  }
  return (
    `You have ${setlistCount} setlists. The Free plan saves 1. ` +
    `Existing setlists stay usable — upgrade to create more.`
  );
}

export default function OverLimitBanner({ tierInfo, role, songCount, setlistCount, onUpgrade }) {
  if (role !== "admin") return null;
  if (!tierInfo?.overLimitReasons?.length) return null;
  if (tierInfo?.tier !== "free") return null;

  const message = buildCopy(tierInfo.overLimitReasons, songCount, setlistCount);

  return (
    <div className="w-full border-l-4 border-brand-gold bg-surface px-5 py-3.5 flex items-center justify-between gap-4">
      <p className="text-text-secondary text-[0.875rem] leading-[1.6]">{message}</p>
      <button
        onClick={onUpgrade}
        className="shrink-0 bg-brand-gold text-[#0d0d0c] font-bold border-0 rounded-sm px-5 py-2 text-[0.75rem] tracking-[0.14em] uppercase hover:bg-brand-gold/85 transition-colors"
      >
        Upgrade
      </button>
    </div>
  );
}
